import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {safeOptional} from '../../safe-optional'
import {LinkSchema} from './link'

export const LinkGroupSchema = buildEntrySchemaFor('linkGroup', {
  fields: z.lazy(() =>
    z.object({
      heading: LinkSchema,
      links: safeOptional(z.array(LinkSchema)),
    }),
  ),
})

export type LinkGroup = z.infer<typeof LinkGroupSchema>
